import { JSXElement, mergeProps } from 'solid-js';
import Logo from '~/pages/ExternalPages/commons/Logo.tsx';
import HostedAuthBoxContainer from '~/pages/ExternalPages/commons/components/HostedAuthBoxContainer.tsx';
import { usePortalCustomizationContext } from '~/portal-customization/PortalCustomizations.tsx';

type HostedAuthGenericBoxWithLogoProps = {
  children: JSXElement;
};

export default function HostedAuthGenericBoxWithLogo(
  props: HostedAuthGenericBoxWithLogoProps
): JSXElement {
  const merged = mergeProps({}, props);
  const portalCustomization = usePortalCustomizationContext();

  return (
    <HostedAuthBoxContainer>
      <div
        class={`w-full flex flex-col p-6 sm:p-10 rounded-lg bg-bg-canvas justify-center items-center border border-border-subtle`}
      >
        <Logo logoPosition={portalCustomization.brandConfig?.logoPosition} />
        {merged.children}
      </div>
    </HostedAuthBoxContainer>
  );
}
